/**
 * @file index.tsx
 *
 * @fileoverview Shows the add link for multi widgets like education or work experience.
 */

import React, { useContext } from 'react';
import Link from '~/jobiqo/components/Link';
import { UserContext, UserContextInterface } from '~/jobiqo/context/user';
import { OrganizationProfile } from '~/jobiqo/types/types';
import { getCommonTranslations } from '~/jobiqo/utils/intl';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { HiddenVisually as VisuallyHidden } from '~/vcl/atoms/14-w-a11y/02-visually-hidden';
import { AddCircleIcon } from '~/vcl/icons/AddCircle';

export interface AddLinkProps {
  boxId: string | undefined;
  /**
   * The current user resume.
   */
  organization: OrganizationProfile;
}

export const AddLink = ({ boxId, organization }: AddLinkProps) => {
  const userContext: UserContextInterface = useContext(UserContext);
  const { ADD, EDIT } = getCommonTranslations();

  return userContext.user && organization.canEdit ? (
    <Link
      href={`/organization/edit/${organization.id}/${boxId}/new`}
      scroll={false}
      data-testid={`jbq-organization-add-${boxId}`}
    >
      <Button
        buttonStyle="grayLight"
        bordered={false}
        rounded
        iconed
        dense
        className="jd-org-add-link-btn"
      >
        <VisuallyHidden>{EDIT}</VisuallyHidden>
        <span>{ADD}</span>
        <AddCircleIcon title={ADD} />
      </Button>
    </Link>
  ) : null;
};
